import standardProducts from '../assets/images/products/standard-products.png';
import precisionScrews from '../assets/images/products/precision-screws.png';
import screwMachineParts from '../assets/images/products/screw-machine-parts.png';
import threadFormingScrews from '../assets/images/products/thread-forming-screws.png';
import semsScrew from '../assets/images/products/sems-screw.png';
import lockingParts from '../assets/images/products/locking-parts.png';
import springs from '../assets/images/products/springs.png';
import cuttingParts from '../assets/images/products/cutting-parts.png';
import coldHeadingParts from '../assets/images/products/cold-heading-parts.png';
import plasticParts from '../assets/images/products/plastic-parts.png';
import powderedMetalParts from '../assets/images/products/powdered-metal-parts.png';

const products = [
  {
    id: 1,
    name: 'Standard Products',
    image: standardProducts,
    description: 'A wide line of standard JIS, JCIS, DIN and American standard parts — developed and distributed with our partners, with excellent lead times even on special items and small lots.',
    details: [
      "We aggressively seek to develop new products in anticipation of our customers' changing needs. At the same time, we continue to distribute a wide line of standard JIS, JCIS, DIN and American standard parts manufactured by our partners.",
      'We strive to seek out or design new fastening methods and devices and to engineer products that meet the maximum potential for each type of fastener that we distribute.',
      'We do all of this while maintaining excellent lead time within industry standards, even for special items and small lots.',
    ],
  },
  {
    id: 2,
    name: 'Precision Screws',
    image: precisionScrews,
    description: '#0 JCIS and #00 cross-recess precision screws — the standards for which were developed by Tokyo Byokane and are widely adopted across the manufacturing industry.',
    details: [
      'Since our precision screws were incorporated into the standards of JCIS (Japanese Camera Industrial Standard) developed by Tokyo Byokane, our #0 JCIS screws have enjoyed continuously increasing acceptance in many areas of manufacturing.',
      'In response to the world-wide demand for even smaller screws, our partners can develop and introduce the #00 cross-recess screw. Both fasteners — noted for their exact standards, precise cold heading, clean recess punches, and thread forms — have enjoyed immediate acceptance and success.',
      'Our ability to mass-produce these parts and distribute them efficiently has enabled us to provide higher quality finished products at lower cost to our customers.',
    ],
  },
  {
    id: 3,
    name: 'Screw Machine Parts',
    image: screwMachineParts,
    description: 'High-precision machined parts for information processing devices, multimedia systems, and audio/video equipment — produced on the latest screw machines with small minimum lots and competitive cost.',
    details: [
      'In order to meet the more complicated demands of our customers, our partners are equipped with the latest screw machines. This enables us to produce parts with an extremely high degree of precision while maintaining small minimum lot quantities and competitive costs.',
      'These high-quality parts are now part of our everyday life in information processing devices, multimedia systems, audio and video equipment, and many others.',
    ],
  },
  {
    id: 4,
    name: 'Thread Forming Screws',
    image: threadFormingScrews,
    description: '"Taptites" with trilobular cross-sections used worldwide across many industries — lower initial torque, no cutting residue, and excellent holding strength.',
    details: [
      'These fasteners, known as "Taptites" or "thread forming screws," have trilobular cross-sections and are used throughout the world in a variety of industries and applications.',
      'They require less initial torque, leave no cutting residue or chips, and have excellent holding strength.',
      'Thread forms are specifically designed for use in plastics, aluminum, and steel, as well as many other materials. They can also be made with various head styles, recesses, and finishes to meet your needs.',
      'We look forward to receiving your orders and fulfilling your requirements for this type of fastener.',
    ],
  },
  {
    id: 5,
    name: 'SEMS Screw (Built-in Washer)',
    image: semsScrew,
    description: 'Pre-assembled screw-and-washer fasteners ideal for compact products — seamless integration, lower risk of failure, and faster, safer assembly.',
    details: [
      'SEMS screws work well in products with small dimensions, allowing seamless integration with a lower risk of failure, and can help make the assembly process easier and safer.',
      'A variety of SEMS screws are readily available in JIS Standard / Taptite variants, depending on the design specifications and demand of your projects.',
    ],
  },
  {
    id: 6,
    name: 'Locking Parts',
    image: lockingParts,
    description: 'A range of locking fasteners engineered to solve the age-old problem of parts loosening in service — without relying on excessive installation torque.',
    details: [
      'For years our industry has been searching for a solution to the problem of parts becoming loose in their application, other than just using more torque in the installation process.',
      'We have spent a great deal of time on this issue looking for the best partners to produce these parts.',
      'We currently offer different varieties of unique locking parts that can meet your needs and solve your problems.',
    ],
  },
  {
    id: 7,
    name: 'Springs',
    image: springs,
    description: 'Precision coil springs produced in our specialized partner factory in China — push or pull, built to function reliably in demanding applications.',
    details: [
      'At a glance, springs may seem like very simple mechanisms — they either push or pull.',
      'However, producing a quality spring that will function properly requires a great deal of technological expertise and know-how. We have a specialized coil-spring factory in China where we apply our production skills to achieve the development of precision spring products of the highest quality.',
    ],
  },
  {
    id: 8,
    name: 'Cutting Parts',
    image: cuttingParts,
    description: 'Mechanical shafts and transmission components — commonly in stainless steel — that transmit motion, torque, or bending moments in precision assemblies.',
    details: [
      'Cutting parts are mechanical parts that transmit motion, torque, or bending moments — generally round metal bars with different diameters in each segment. They can be long or small shafts. Stainless steel materials are commonly used for these parts.',
      'Producing quality shafts and mechanical parts requires expert skill and knowledge. We have partners in Asian countries who can develop and produce parts depending on your specifications and demand.',
    ],
  },
  {
    id: 9,
    name: 'Cold Heading Parts',
    image: coldHeadingParts,
    description: 'Cost-effective cold-headed parts in a wide range of metals, sizes, and configurations — manufactured by carefully vetted partners to meet varied customer requirements.',
    details: [
      'We have seen the advantage of special cold-headed parts. Cold heading is one of the most cost-effective methods, used for a wide range of metals, sizes, and configurations depending on the type of parts needed for machinery.',
      'These advantages lead us to seek out the best partners to manufacture and ensure that parts conform to and meet the various requirements and demand of our customers.',
    ],
  },
  {
    id: 10,
    name: 'Plastic Parts',
    image: plasticParts,
    description: 'ABS, Nylon, and engineered-plastic parts offering high strength at very light weight — a wide standard range backed by decades of Tokyo Byokane Group supply.',
    details: [
      'Our plastic products offer high strength at very light weights.',
      'The Tokyo Byokane Group has been supplying plastic parts for many years, and we maintain a wide variety of standard items to meet the needs of our customers.',
      'These parts are available in a number of materials including ABS, Nylon, and various engineered plastics.',
      'We are continually searching for new and better materials for these applications.',
    ],
  },
  {
    id: 11,
    name: 'Powdered Metal Parts',
    image: powderedMetalParts,
    description: 'Sintered parts formed from combinations of metal powders — exceptional strength at relatively light weight, at very competitive cost.',
    details: [
      "These metal parts are manufactured using combinations of metal powders to meet our customers' needs and specifications.",
      "The parts are formed under pressure and fused in a furnace at temperatures just below the materials' melting point.",
      'This gives the finished products exceptional strength at relatively light weight, and at very competitive cost.',
      'Today, powdered metal parts are used in a wide variety of products assembled throughout the world.',
    ],
  },
];

export default products;
